<template>
  <footer>
    <div class="container">
      <div class="row row-20" style="width: 100%;">
        <img src="@/assets/footer_logo.svg" class="mb-sm-1" width="160" />
      </div>
      <div class>
        <h3>サポートセンター</h3>
        <p>合同会社プロンエイド</p>
        <p>〒104-0031</p>
        <p>東京都渋谷区西原3-2-2 クボタビル4F</p>
        <p>support@pronaid.co.jp (仮表示)</p>
      </div>
    </div>
  </footer>
</template>

<script>
const lessons = require("@/resources/lessons");

export default {
  data() {
    return {
      dialogVisible: false,
      lessons: []
    };
  },
  methods: {},
  mounted() {
    this.lessons = lessons;
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #555;
  padding: 30px 100px;
}

footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);

  img {
    margin-top: 20px;
  }

  h3 {
    font-size: 1.3rem;
    font-weight: bold;
    margin: 10px 0;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  li {
    margin-bottom: 6px;
  }

  p {
    margin: 0;
    padding-top: 10px;
  }
}

a {
  color: #fff !important;
  opacity: 0.9;
}
</style>
